import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { DEFAULT_LABELS, useDenaliScopes, useSelectedDenaliScope } from '../filters/DenaliScopeProvider'
import UserScopeDisplay from './UserScopeDisplay'
import GroupScopeDisplay from './GroupScopeDisplay'

const DenaliScopePicker = ({
  hideAvatars,
  size,
  disableReset,
  multiSelect,
  className
}) => {
  const { scopes, selectScopeValues } = useDenaliScopes()
  const { scope, values } = useSelectedDenaliScope()
  // const { isLoading: myAdvisorLoading, data: myAdvisor } = useMyAdvisor()
  const labels = useMemo(() => {
    return {
      ...DEFAULT_LABELS,
      ...(scope?.labels || {})
    }
  }, [scope])

  // if no scope is available, then show an unchangeable label
  if (!scope) {
    return (
      <UserScopeDisplay
        name={labels?.allItems}
        subTitle={labels?.subTitle}
        hideAvatars={hideAvatars}
        size={size}
      />
    )
  }

  // otherwise display the
  return (
    <GroupScopeDisplay
      availableScopes={scopes}
      scope={scope}
      scopeValues={values}
      setScope={selectScopeValues}
      hideAvatars={hideAvatars}
      size={size}
      disableReset={disableReset}
      labels={labels}
      multiSelect={multiSelect}
      className={className}
    />
  )
}

DenaliScopePicker.propTypes = {
  /** Determines the visual size of the picker */
  size: PropTypes.oneOf(['sm', 'lg']),

  /** Should the component hide avatars? */
  hideAvatars: PropTypes.bool,

  /** Should the component disable resetting its value on an outdated selection? */
  disableReset: PropTypes.bool,

  /** Should the component allow selecting multiple values? */
  multiSelect: PropTypes.bool,

  /** Additional CSS classes to be applied to component */
  className: PropTypes.string
}

DenaliScopePicker.defaultProps = {
  size: 'sm',
  multiSelect: false
}

export default DenaliScopePicker
